import * as React from "react";
import { useNavigate } from "react-router-dom";

import Debug from "@/react/debug";
import * as PATHS from "@/react/routing/constants";

/**
 * This hooks returns a callback that is used to redirect to VCC Agent Assignments.
 * It uses the History API to provide agentId and queueId as state, which are
 * going to be turned into filters by the {@see AgentAssignmentsPage} logic.
 *
 * @return {(function(*): void)|*}
 */
const useNavigateToAgentAssignments = () => {
  const navigate = useNavigate();

  return React.useCallback(
    (params) => {
      Debug.log(
        `[useNavigateToAgentAssignments callback] Going to ${PATHS.VCC_AGENT_ASSIGNMENTS}.`,
        params
      );

      const agentId = params?.agentId;
      const queueId = params?.queueId;
      navigate(PATHS.VCC_AGENT_ASSIGNMENTS, {
        state: {
          agentId,
          queueId,
        },
      });
    },
    [navigate]
  );
};

export default useNavigateToAgentAssignments;
